import { Map } from 'immutable';

import * as t from '../actions/signUpActionTypes';

const initialState = Map({
  rates: [],
  plans: [],
  references: [],
  referencesPmk: [],
  loadingReferences: false,
  cycle: {},
  chaptersWithoutQuestions: 0,
  chaptersCount: 0,
  questionsOccupationalCounter: 0,
  questionsPmkCounter: 0,
  chaptersPmkCount: 0,
  chaptersPmkWithoutQuestions: 0,
  checkEmailExistsWaiting: false,
  checkEmailExistsSuccess: false,
  checkEmailExistsMessage: { exists: false, requested: false },
  subscriptionWaiting: false,
  subscriptionMessage: '',
  subscriptionSuccess: false,
  ratingExamQuestions: null,
  coupon: '',
  quals: [],
});

const reducer = function featuredBlogReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_RATES:
      return state.set('rates', action.rates);
    case t.SET_PLANS:
      return state.set('plans', action.plans);
    case t.SET_LOADIG_REFERENCES:
      return state.set('loadingReferences', action.value);
    case t.SET_REFERENCES:
      return state.set('references', action.references);
    case t.SET_QUALS:
      return state.set('quals', action.quals);
    case t.SET_REFERENCES_PMK:
      return state.set('referencesPmk', action.referencesPmk);
    case t.SET_CYCLE:
      return state.set('cycle', action.cycle);
    case t.SET_COUNTERS:
      return state
        .set('chaptersWithoutQuestions', action.chaptersWithoutQuestions)
        .set('chaptersCount', action.chaptersCount)
        .set('questionsOccupationalCounter', action.questionsOccupational)
        .set('questionsPmkCounter', action.questionsPmk)
        .set('chaptersPmkCount', action.chaptersPmkCount)
        .set('chaptersPmkWithoutQuestions', action.chaptersPmkWithoutQuestions);
    case t.SET_CHECK_EMAIL_EXISTS_MESSAGE:
      return state.set('checkEmailExistsMessage', action.message);
    case t.SET_CHECK_EMAIL_EXISTS_SUCCESS:
      return state.set('checkEmailExistsSuccess', action.value);
    case t.SET_CHECK_EMAIL_EXISTS_WAITING:
      return state.set('checkEmailExistsWaiting', action.value);
    case t.SET_SUBSCRIPTION_MESSAGE:
      return state.set('subscriptionMessage', action.message);
    case t.SET_SUBSCRIPTION_SUCCESS:
      return state.set('subscriptionSuccess', action.value);
    case t.SET_SUBSCRIPTION_WAITING:
      return state.set('subscriptionWaiting', action.value);
    case t.SET_RATING_EXAM_QUESTIONS:
      return state.set('ratingExamQuestions', action.ratingExamQuestions);
    case t.RESET_COMPONENT:
      return state
        .set('rates', initialState.get('rates'))
        .set('plans', initialState.get('plans'))
        .set('references', initialState.get('references'))
        .set('referencesPmk', initialState.get('referencesPmk'))
        .set('loadingReferences', initialState.get('loadingReferences'))
        .set('cycle', initialState.get('cycle'))
        .set(
          'chaptersWithoutQuestions',
          initialState.get('chaptersWithoutQuestions'),
        )
        .set('chaptersCount', initialState.get('chaptersCount'))
        .set(
          'questionsOccupationalCounter',
          initialState.get('questionsOccupationalCounter'),
        )
        .set('questionsPmkCounter', initialState.get('questionsPmkCounter'))
        .set('chaptersPmkCount', initialState.get('chaptersPmkCount'))
        .set(
          'chaptersPmkWithoutQuestions',
          initialState.get('chaptersPmkWithoutQuestions'),
        )
        .set(
          'checkEmailExistsWaiting',
          initialState.get('checkEmailExistsWaiting'),
        )
        .set(
          'checkEmailExistsSuccess',
          initialState.get('checkEmailExistsSuccess'),
        )
        .set(
          'checkEmailExistsMessage',
          initialState.get('checkEmailExistsMessage'),
        )
        .set('subscriptionWaiting', initialState.get('subscriptionWaiting'))
        .set('subscriptionMessage', initialState.get('subscriptionMessage'))
        .set('subscriptionSuccess', initialState.get('subscriptionSuccess'))
        .set('ratingExamQuestions', initialState.get('ratingExamQuestions'));
    case t.SET_COUPON:
      return state.set('coupon', action.coupon);
    default:
      return state;
  }
};

export default reducer;
